<template>
  <v-container grid-list-sm grid-list-md fluid class="tabelaBox">
    <v-layout row wrap>
      <v-flex xs12 sm6 md8>
        <h5>
          Seu negócio
        </h5>
        <p>Selecione uma categoria de interesse para fornecer seus produtos e/ou serviços</p>
      </v-flex>
      <v-flex xs12 sm12 md7>
        <div :class="sugestao ? 'input-search disabled': 'input-search'">
          <v-icon class="mr-2">search</v-icon>
          <input v-model="pesquisar" type="text" name="" value="" placeholder="Procurar"  :disabled="sugestao">
        </div>
      </v-flex>
    </v-layout>
    <template v-if="!(filtroClasseSugerida === false || filtroClasseSugerida === [])">
      <div class="mt-4">
        <v-layout row wrap class="chips-selecionados">
          <v-flex xs12>
            <span class="font-red pa-3 espacamento">Categoria<span v-if="filtroClasseSugerida.categoriasLista.length !== 1">s</span> escolhida<span v-if="filtroClasseSugerida.categoriasLista.length !== 1">s</span></span>
            <v-chip close @input="removeCategoria(chip.id)" v-for="chip in chipsSelecionadas" :key="chip.id">{{ chip.name }}</v-chip>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mt-1 pb-2" style="border-bottom: 1px solid #d7d7d7;">
          <v-flex xs12>
            <div class="link" @click="resetarCategorias">
              Quero pesquisar novamente
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mt-3 mb-3" style="font-size:16px;" v-if="!sugestao">
          <v-flex xs12>
            Encontramos <strong><span v-if="filtroClasseSugerida.categoriasLista.length < 10">0</span>{{ filtroClasseSugerida.categoriasLista.length }} Categoria<span v-if="filtroClasseSugerida.categoriasLista.length !== 1">s</span></strong> semelhante<span v-if="filtroClasseSugerida.categoriasLista.length !== 1">s</span> <span class="link" @click="sugestao = !sugestao">visualizar</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mt-3 mb-3" style="font-size:16px;" v-else>
          <v-flex xs12>
            <span class="link" @click="sugestao = !sugestao">Voltar a pesquisa</span>
          </v-flex>
        </v-layout>
      </div>
    </template>
    <v-container grid-list-sm grid-list-md text-xs-center fluid>

      <template v-for="(classe, i) of fitroClasse">
        <v-layout row wrap :key="i">
          <v-flex xs12 mt-3 class="text-xs-left">
            <div>{{ classe.nome }}</div>
          </v-flex>
          <template v-for="(categoria, index) of classe.categoriasLista">
            <transition name="fade" :key="index">
              <v-flex xs12 sm6 md4>
                <div class="box">
                  <v-tooltip top v-if="categoria.name.length > 27">
                    <template slot="activator">
                      <v-checkbox
                      :label="categoria.name"
                      v-model="classeSelecionada"
                      style="width:90%;"
                      :value="categoria.id"
                      ></v-checkbox>
                    </template>
                    <span>{{ categoria.name }}</span>
                  </v-tooltip>
                  <template v-else>
                    <v-checkbox
                    :label="categoria.name"
                    v-model="classeSelecionada"
                    style="width:90%;"
                    :value="categoria.id"
                    ></v-checkbox>
                  </template>
                </div>
              </v-flex>
            </transition>
          </template>
        </v-layout>
      </template>

    </v-container>
  </v-container>
</template>

<script>
import classe from './Classe'
export default {
  name: 'tabela-classes',
  components: {
    'classe': classe
  },
  // props: {
  //   categorias: Array,
  // },
  data () {
    return {
      pesquisar: '',
      classes: [],
      loading: true,
      dialog: false,
      sugestao: false
    }
  },
  computed: {
    classeSelecionada: {
      get: function () {
        return this.$store.getters.arrayCategorias
      },
      set: function (idCategoria) {
        if (idCategoria.length > 1) {
          let classes = JSON.parse(JSON.stringify(this.classes))
          classes = classes.filter((elemento) => {
            return elemento.categoriasLista.find(categoria => categoria.id === idCategoria[idCategoria.length - 1])
          })
          if (classes[0].registro !== this.filtroClasseSugerida.registro) {
            this.$store.commit('toastr', {
              color: 'info',
              texto: 'Somente é permitido setores relacionados'
            })
            return
          }
        }
        this.$store.commit('selecionaCategoria', {
          valor: idCategoria
        })
        return
      }
    },
    fitroClasse () {
      if (this.sugestao === true && this.$store.getters.arrayCategorias.length > 0) {
        return [this.filtroClasseSugerida]
      }
      if (this.pesquisar.length > 1) {
        let exp = new RegExp(this.pesquisar.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, ''), 'i')
        let classes = JSON.parse(JSON.stringify(this.classes))
        return classes.filter((classe) => {
          let categorias = classe.categoriasLista.filter((categoria) => {
            return exp.test(categoria.detail.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
          })
          classe.categoriasLista = categorias
          return classe.categoriasLista.length !== 0
        })
      }
      return []
    },
    filtroClasseSugerida () {
      if (this.$store.getters.arrayCategorias.length === 0) {
        return false
      } else {
        let classes = JSON.parse(JSON.stringify(this.classes))
        return classes.filter((elemento) => {
          return elemento.categoriasLista.find(categoria => categoria.id === this.$store.getters.arrayCategorias[0])
        })[0]
      }
    },
    chipsSelecionadas () {
      return this.filtroClasseSugerida.categoriasLista.filter((categoria) => {
        return this.$store.getters.arrayCategorias.indexOf(categoria.id) !== -1
      })
    }
  },
  methods: {
    removeCategoria (idCategoria) {
      this.$store.commit('removeCategoria', {
        valor: idCategoria
      })
      if (this.$store.getters.arrayCategorias.length === 0) {
        this.sugestao = false
      }
    },
    resetarCategorias () {
      this.sugestao = false
      this.$store.commit('resetarCategorias')
    }
  },
  mounted () {
    this.$http.get('Categoria/GetLista')
          .then((response) => {
            let data = response.data.resultado
            this.classes = data.categoriasLista
            this.loading = false
          })
          .catch((error) => {
            this.$store.commit('toastrAxiosError', error)
            this.loading = false
          })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .espacamento{
    font-size: 16px;
  }
  .tabelaBox{
    border: 1px solid #d9d9d9;
    padding: 20px!important;
    border-radius: 8px!important;
  }
  .tabelaBox h5{
    color: #e51b2e;
    margin-bottom: 0;
  }

  .grow-box label{
    height: 63px;
    line-height: 23px;
    text-overflow: inherit;
    white-space: normal;
  }
  .grow-box-2{
    height: 100px;
  }
  .grow-box-2 label{
    height: 100px;
    line-height: 20px;
    text-overflow: inherit;
    white-space: normal;
    margin-top: 5px;
  }
  .chips-selecionados{
    border: 1px solid #d7d7d7;
    background-color: #f4f4f4;
  }
  .font-red{
    color: #e51b2e;
  }
  @media only screen and (max-width: 643px){
    .cadastro-footer{
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      color: #fff;
      background-color: #ea1d24;
      text-align: center;
      padding: 10px;
    }
    .cadastro-footer a{
      color: #fff!important;
      font-weight: bold;
    }
    .cadastro-footer span{
      display: none;
    }
  }
  .box{
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    padding: 8px;
  }
  .box .checkbox{
    padding-top: 5px;
  }
  .box label{
    color: #3c3737!important;
    padding-left: 5px;
    max-width: 83%;
  }
  .box .input-group__input{
    margin-bottom: 12px;
  }
  .tooltip__content.menuable__content__active{
    margin-top: 10px;
  }
  .box .input-group__details{
    display: none;
  }
  .box .classe{
    border-top: 1px solid #d9d9d9;
    text-align: left;
    padding-left: 10px;
  }
  .input-search {
    border: 1px solid #d9d9d9;
    border-radius: 15px;
    padding: 8px;
    position: relative;
  }
  .desaparece{
    display: none;
  }
  .input-search input{
    position: absolute;
    outline: none;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    padding-left: 37px;
    font-size: 22px;
    color: #5a5a5a;
  }
  .disabled{
    background-color: #e0e0e0
  }
</style>



// WEBPACK FOOTER //
// index.vue?0bd0bbd6